import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';

class MidiInterfaceComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    render() {
        let parametersBySection = this.props.effect.ccParameters;
        return (
            <div>
              <div className="external-instrument-name">
                {this.props.effect.midiOutput.name}
              </div>
              <div className="midi-interface-effect">
                <ConditionedComponent condition={this.isEnabled()}>
                  {parametersBySection.map(
                      sections =>
                          <div className="instrument-section">
                                {Object.keys(sections).map(
                                    sectionName =>
                                        <MidiInterfaceSection
                                              section={sections[sectionName]}
                                              sectionName={sectionName}/>)}
                      </div>
                  )}
                </ConditionedComponent>
              </div>
            </div>
        );
    }
}

class MidiInterfaceSection extends Component {
    render() {
        return (
            <div className="external-instrument-subsection">
              <div className="instrument-subsection-name">
                {this.props.sectionName}
              </div>
              <div className="clear-fix"/>
              {Object.keys(this.props.section).map(
                  parameterName =>  
                      <EffectParameterSlider
                            effectNumber={this.props.effectNumber}
                            name={parameterName}
                            parameter={this.props.section[parameterName]}
                            onParameterChanged={this.props.onParameterChanged}
                            isParameter={true}
                            step={1}
                            min={0}
                            max={127}/>
              )}
            </div>
        );
    }
}

export default MidiInterfaceComponent;
